import { Component, Input, OnInit,Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { BaseDynamicForm } from 'src/app/core/services/base-dynamic-form';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CostFormService } from 'src/app/core/services/cost-form.service';
import {Subject} from 'rxjs';
import {  ControlValueAccessor, 
          NG_VALUE_ACCESSOR, 
          FormBuilder,
          FormGroup,          
          Validators,
          FormControl,
          NG_VALIDATORS
        } from '@angular/forms';

// Interface para recomendaciones médicas
interface MedicalRecommendation {
  id: number;
  doctorName: string;
  specialty: string;
  date: Date;
  diagnosis?: string;
  isAvailable: boolean;
  description?: string;
  patientName?: string;
  medicalCenter?: string;
}

@Component({
  selector: 'prgov-cost-form',
  templateUrl: './cost-form.component.html',
  styleUrls: ['./cost-form.component.scss'],
  
})
export class CostFormComponent extends BaseDynamicForm implements OnInit {

    @Output() saveDynamicCosts: EventEmitter<any> = new EventEmitter<any>();

    @Input() dynamicCostChange: Subject<any>;
    costs: [];
    invoice: any = [];
    cost: any = [];
    numberOfCostsRequired: any = 0;

    // Propiedades para recomendaciones médicas
    selectedApplicant: string = 'adulto';
    ssnSearch: string = '';
    recommendations: MedicalRecommendation[] = [];
    searched: boolean = false;
    selectedRecommendation: MedicalRecommendation | null = null;
    isLoading: boolean = false;

    constructor(    
        private route:ActivatedRoute,
        private router: Router,
        public dialog: MatDialog,
        public translate: TranslateService,
        public dynamicFormService: DynamicFormService,
        public costFormService: CostFormService,
        public authService: AuthService
    ) {
        super();
        console.log('CostFormComponent constructor ejecutado');  

        translate.use(this.ls.get(this.langKey));

        this.dynamicFormService.formCommunicator.subscribe((data) => {
            if(data=="save-data"){
              this.save();
            }
        });  
         
        this.costFormService.total = 0;
        this.costFormService.costs = [];
        this.costFormService.selectedCosts = [];
        this.costFormService.dynamicCosts = [];
        this.costFormService.subTotal = 0;  
        this.costFormService.total = 0;  
        this.costFormService.taxAmount = 0;  
        this.costFormService.discountAmount = 0; 
   
        this.costFormService
        .getCosts(this.dynamicFormService.requirement.ProcessId, this.dynamicFormService.costTypeId)
        .then((data: any)=>{
          // this.costFormService.minRequiredCosts = data[0].Min;
          console.log(this.costFormService.minRequiredCosts);
        });       
    }

    ngOnInit() {
        console.log('CostFormComponent ngOnInit ejecutado');
        // Inicializar con datos de ejemplo para testing
        this.loadSampleRecommendations();
        console.log('Recomendaciones cargadas:', this.recommendations);
    }
    
    save(){
      this.costFormService
      .save(
        this.dynamicFormService.requirement.ProcessId, 
        {  
          "costs": 
          JSON.stringify(this.costFormService.selectedCosts)
        }
      );
    }

    // Métodos para recomendaciones médicas
    searchBySSN() {
        if (!this.ssnSearch) {
            return;
        }

        this.isLoading = true;
        this.searched = true;

        // Simular búsqueda por SSN (reemplazar con llamada real al servicio)
        setTimeout(() => {
            this.recommendations = this.getSampleRecommendations();
            this.isLoading = false;
        }, 1000);
    }

    continue() {
        if (this.selectedRecommendation) {
            // Aquí iría la lógica para continuar con el proceso
            console.log('Continuando con recomendación:', this.selectedRecommendation);
        }
    }


    closeDetailModal() {
        this.selectedRecommendation = null;
    }

    private getSampleRecommendations(): MedicalRecommendation[] {
        // Datos de ejemplo para testing basados en la imagen
        return [
            {
                id: 1,
                doctorName: 'Dr. Juan Pérez',
                specialty: 'Cardiología',
                date: new Date('2024-01-15'),
                diagnosis: 'Hipertensión arterial',
                isAvailable: true,
                description: 'Recomendación para control de presión arterial',
                patientName: 'Test 123',
                medicalCenter: 'Hospital Central'
            }
        ];
    }

    private loadSampleRecommendations() {
        this.recommendations = this.getSampleRecommendations();
    }
}

